import date from "date-and-time";
import { getLocaleDateFormat } from "@/utils/date_formatter";

export const csvFilename = (type: string): string => {
  const today = new Date();
  const formattedDate = date.format(today, getLocaleDateFormat());
  const fileName = `./${type}_${formattedDate}.csv`;
  return fileName;
};

export const isValidString = (value: any): boolean => {
  return typeof value === "string" && value !== null && value !== undefined && value.trim() !== "";
};

export const replacePlaceholder = (template: string, values: { [key: string]: string }): string => {
  return template ? template.replace(/{\s*(\w+)\s*}/g, (_, key): string => (values[key] ? values[key] : "")) : "";
};
